import React, { useEffect, useState } from 'react'
import lpllogo from '../../assets/images/logo.png';
import suburbunlogo from '../../assets/images/suburban.webp';
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/feedback.scss';
// import getUserDetails from "./";
// import getUserDetails from "../utilities/getUserDetails";
import GetUserData from '../../utilities/getUserDetails';
import 'font-awesome/css/font-awesome.min.css';
import Button from 'react-bootstrap/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

function LabNumber() {
    const location = useLocation();
    const navigate = useNavigate();
    const query = queryString.parse(location.search);
    const selectedOption = decodeURIComponent(query.selectedOption);
    const selectedProject = decodeURIComponent(query.project);
    // alert(selected);
    // alert(selectedProject);
    const lang = decodeURIComponent(query.lang);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [userInfo, setUserInfo] = useState(GetUserData());
    useEffect(() => {
        setSelectedLanguage(lang);
    }, [selectedOption, lang]);
    const handleSubmit = () => {
        navigate(`/thanks`);
    };
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
    return (
        <>
            <div className='container-fluid feedback-form'>
                <div className='row'>
                    <div className='col-14 col-sm-14 col-md-9 col-lg-9 col-xl-9 '>
                        <div className='logo-section'>
                             {isSuburban ? (
                                <img alt="Suburban Diagnostics India Pvt Limited" className='f-logo' src={suburbunlogo} />
                            ) : (
                                <img alt="Dr Lal Path Labs" className='f-logo' src={lpllogo} />
                            )}
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-8 col-lg-10 col-xl-10'>
                        <div className='form-section'>
                            <div className='me-4 row'>
                                
                                {selectedProject == 1 && (
                                <div className='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 text-center'>
                                    
                                    <h5 className='feedback-title mb-3' style={{ fontSize: '16px' }}>
                                        {isSuburban ? (
                                            selectedLanguage === 'eng'
                                                ? 'Did you receive 9-digit bar code (Lab number) after sample collection by Suburban Diagnostics India Pvt Limited staff?'
                                                : 'क्या आपको "सबर्बन डायग्नोस्टिक्स इंडिया प्रायव्हेट लिमिटेड के स्टाफ द्वारा सैंपल संग्रह के बाद 9-अंकीय बार कोड (लैब नंबर) मिला?'
                                        ) : (
                                            selectedLanguage === 'eng'
                                                ? 'Did you receive 9-digit bar code (Lab number) after sample collection by Dr. Lal PathLabs staff?'
                                                : 'क्या आपको डॉ. लाल पथलैब्स के स्टाफ द्वारा सैंपल संग्रह के बाद 9-अंकीय बार कोड (लैब नंबर) मिला?'
                                        )}
                                    </h5>

                                    <div className='text-center yes-no mb-4'>
                                        <Button variant='success me-3 active' style={{ width: '110px', minHeight: '36px', borderRadius: '20px' }}> <i className='fa fa-check me-2'></i> Yes</Button>
                                        <Button variant='danger' style={{ width: '110px', minHeight: '36px', borderRadius: '20px' }}>  <i className='fa fa-check me-2'></i> No</Button>
                                    </div>
                                </div>
                                )}
                                <div className='col-10 col-sm-10 col-md-12 col-lg-10 col-xl-10 text-center'>
                                    <h5 className='feedback-title mb-3' style={{ fontSize: '16px' }}>
                                        {selectedLanguage === 'eng' ? 'If you have any other feedback or suggestions, please let us know below.' : 'यदि आपके पास कोई अन्य फीडबैक या सुझाव हैं, तो कृपया नीचे हमें बताएं।'}
                                    </h5>
                                    <div className='textareafeedback mb-4'>
                                        <div className="text-center did-floating-label-content col-10">
                                            <textarea className='did-floating-input px-3 py-2' rows={'3'} placeholder='Write here' style={{ minHeight: '80px' }}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='button-footer text-center'>
                            <div className='row justify-content-center'>
                                <div className='col-10 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
                                    <Button variant='primary w-100' style={{ minHeight: '36px', borderRadius: '20px' }} onClick={handleSubmit}>Submit</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default LabNumber;
